import { DEFAULT_VISIBLE_COLUMNS } from '@app/data/manageTasks/taskAttributes';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { LocalStorage } from '@vectord/utils';

export interface TableConfigType {
  size: 'large' | 'middle' | 'small';
}

export interface ManageLeadsState {
  page: number;
  taskList: {
    itemsPerPage: number;
    visibleColumns: string[];
    tableConfig: TableConfigType;
  }
}

const lsInstance = LocalStorage.getInstance('store.tasks.manageTasks');

const initialState: ManageLeadsState = {
  page: 1,
  taskList: {
    itemsPerPage: 10,
    visibleColumns: DEFAULT_VISIBLE_COLUMNS,
    tableConfig: {
      size: 'large',
    },
  },
};

const savedConfig: ManageLeadsState = lsInstance?.config;

export const manageTasksSlice = createSlice({
  name: 'manageTasks',
  initialState: { ...initialState, ...savedConfig },
  reducers: {
    updateItemsPerPage: (state, action: PayloadAction<number>) => {
      state.taskList.itemsPerPage = action.payload;
    },
    updateCurrentPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    resetCurrentPage: (state) => {
      state.page = initialState.page;
    },
    updateTableConfig: (state, action: PayloadAction<Partial<TableConfigType>>) => {
      state.taskList.tableConfig = {
        ...state.taskList.tableConfig,
        ...action.payload,
      };
    },
    setVisibleColumns: (state, action: PayloadAction<string[]>) => {
      state.taskList.visibleColumns = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('manageTasks/'),
      (state) => { lsInstance.config = state; },
    );
  },
});

export const {
  updateItemsPerPage,
  updateCurrentPage,
  resetCurrentPage,
  updateTableConfig,
  setVisibleColumns,
} = manageTasksSlice.actions;

export default manageTasksSlice.reducer;
